import { render, staticRenderFns } from "./InstallPWA.vue?vue&type=template&id=0dcbb7c6&scoped=true&"
import script from "./InstallPWA.vue?vue&type=script&lang=js&"
export * from "./InstallPWA.vue?vue&type=script&lang=js&"
import style0 from "./InstallPWA.vue?vue&type=style&index=0&id=0dcbb7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcbb7c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dcbb7c6')) {
      api.createRecord('0dcbb7c6', component.options)
    } else {
      api.reload('0dcbb7c6', component.options)
    }
    module.hot.accept("./InstallPWA.vue?vue&type=template&id=0dcbb7c6&scoped=true&", function () {
      api.rerender('0dcbb7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/welfareCenter/InstallPWA.vue"
export default component.exports